import { ComponentMultiStyleConfig } from '@chakra-ui/react';
import type { StyleFunctionProps, PartsStyleObject } from '@chakra-ui/theme-tools';
import { mode } from '@chakra-ui/theme-tools';

import { avatarBoxStyles, containerSizeStyleMap } from '../../atoms/Avatar/AvatarTheme';

import TYPOGRAPHY from 'theme/Typography';

const AvatarGroupTheme: ComponentMultiStyleConfig = {
  parts: ['avatarList', 'excessLabel'],
  baseStyle: (props: StyleFunctionProps): PartsStyleObject => ({
    avatarList: {
      display: 'flex',
      flexDirection: props.staggered ? 'column' : 'row',
      gap: props.staggered ? '0' : '4px'
    },
    excessLabel: {
      ...avatarBoxStyles,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1,
      fontWeight: TYPOGRAPHY.fontWeights.medium,
      backgroundColor: mode('silver.base', 'black.lightest')(props),
      color: mode('grey.base', 'silver.base')(props),
      marginLeft: props.staggered && '0.85em',
      marginTop: props.staggered && '-1.15em'
    }
  }),
  sizes: {
    '2xs': {
      excessLabel: containerSizeStyleMap['2xs']
    },
    xs: {
      excessLabel: containerSizeStyleMap.xs
    },
    sm: {
      excessLabel: containerSizeStyleMap.sm
    },
    md: {
      excessLabel: containerSizeStyleMap.md
    },
    lg: {
      excessLabel: containerSizeStyleMap.lg
    },
    xl: {
      excessLabel: containerSizeStyleMap.xl
    },
    '2xl': {
      excessLabel: containerSizeStyleMap['2xl']
    },
    '3xl': {
      excessLabel: containerSizeStyleMap['3xl']
    },
    '4xl': {
      excessLabel: containerSizeStyleMap['4xl']
    }
  }
};

export default AvatarGroupTheme;
